module.exports = __webpack_public_path__ + "img/doll.a0d5d197.svg";